import React, { useRef, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import SourceExploring from './SourceExploring.js';
import YearExploring from './YearExploring.js';
import '../../Xanadu.scss';


export default ({sequencerEngine, sourceExploring, setSourceExploring}) => { 
    return [
        <SourceExploring sequencerEngine={sequencerEngine}/>,
        <YearExploring sequencerEngine={sequencerEngine}/>,
    ];
};
